// Definición de defaults

export const defaultTipoIrregular: TipoIrregularProps = {
    idTipoIrregular:    0,
    descripcion:        '',
    activo:             false
};

// Creación de interfaces

export interface TipoIrregularProps   {
    idTipoIrregular:    number;
    descripcion:        string;
    activo:             boolean;
}